import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @typescript-eslint/no-explicit-any */
export class Observer {
  constructor() {
    var _this = this;
    _defineProperty(this, "listeners", []);
    _defineProperty(this, "unsubscribed", []);
    _defineProperty(this, "on", listener => {
      const isSubscribed = this.listeners.includes(listener);
      if (!isSubscribed) {
        this.listeners.push(listener);
      }
      return () => {
        this.scheduleUnsubscribe(listener);
      };
    });
    _defineProperty(this, "emit", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      [..._this.listeners].forEach(listener => {
        const isUnsubscribed = _this.unsubscribed.includes(listener);
        if (!isUnsubscribed) {
          listener(...args);
        }
      });
    });
    _defineProperty(this, "unsubscribeTimer", void 0);
  }
  scheduleUnsubscribe(listener) {
    this.unsubscribed.push(listener);
    this.listeners = this.listeners.filter(item => item !== listener);
    clearTimeout(this.unsubscribeTimer);
    this.unsubscribeTimer = setTimeout(() => {
      this.unsubscribed = [];
    }, 0);
  }
}